export default __webpack_public_path__ + "static/media/certificate-dish.210395b1.png";